import { Heading, IconButton } from 'copilot-design-system';
import React from 'react';

import { PreviewTooltip } from 'src/legacy/components/Files/ChannelContent/components/filePreviewDialog/PreviewTooltip';

const PageIndicator = ({
  pages,
  activePage,
  onPageChange,
}: {
  pages: number;
  activePage: number;
  onPageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <div className="flex py-3 items-center h-11 text-white text-sm ">
      <Heading size="sm" className="text-white mr-3">
        Page
      </Heading>
      <div className="mr-2 bg-black rounded-[2px] w-9">
        <input
          type="number"
          max={pages}
          value={activePage}
          className="p-0 bg-transparent border-none text-white text-center w-full"
          onChange={onPageChange}
        />
      </div>
      / <span className="ml-3">{pages}</span>
    </div>
  );
};

const ZoomControls = ({
  onZoomIn,
  onZoomOut,
  resetZoom,
}: {
  onZoomIn: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onZoomOut: (e: React.MouseEvent<HTMLButtonElement>) => void;
  resetZoom: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    <div className="flex justify-center items-center h-11 gap-2">
      <PreviewTooltip label="Zoom out">
        <IconButton
          className="bg-transparent hover:bg-[#4B4B4B]"
          onClick={onZoomOut}
          icon="Dash"
          label="Zoom out"
        />
      </PreviewTooltip>
      <PreviewTooltip label="Reset zoom">
        <IconButton
          className="bg-transparent hover:!bg-[#4B4B4B]"
          onClick={resetZoom}
          icon="ResetZoom"
          label="Reset zoom"
        />
      </PreviewTooltip>

      <PreviewTooltip label="Zoom in">
        <IconButton
          className="bg-transparent hover:!bg-[#4B4B4B]"
          onClick={onZoomIn}
          icon="Plus"
          label="Zoom in"
        />
      </PreviewTooltip>
    </div>
  );
};

export const PreviewControls = ({
  pages,
  activePage,
  onZoomIn,
  onZoomOut,
  resetZoom,
  onPageChange,
}: {
  pages?: number;
  activePage?: number;
  onZoomIn: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onZoomOut: (e: React.MouseEvent<HTMLButtonElement>) => void;
  resetZoom: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onPageChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  /**
   * This function handles the preview controls action zoom in, zoom out, and reset zoom click events.
   * It should prevent the event from bubbling up to the parent elements. For instance, we want to prevent
   * the click away listener from triggering when we click on the preview controls.
   * @param e - The event object
   * @param action - The action function to call
   */
  const handlePreviewControlAction = (
    e: React.MouseEvent<HTMLButtonElement>,
    action: (e: React.MouseEvent<HTMLButtonElement>) => void,
  ) => {
    e.stopPropagation();
    action(e);
  };

  return (
    <div
      className="flex justify-center items-center px-3 gap-2 rounded-4 h-11 w-fit fixed bottom-0 mb-4 z-10 bg-black bg-opacity-84"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {onPageChange && (
        <>
          <PageIndicator
            pages={pages ?? 0}
            activePage={activePage ?? 0}
            onPageChange={onPageChange}
          />
          <hr
            className="h-11 w-[1px] mx-2 border-none bg-divider"
            key="divider"
          />
        </>
      )}
      <ZoomControls
        onZoomIn={(e) => handlePreviewControlAction(e, onZoomIn)}
        onZoomOut={(e) => handlePreviewControlAction(e, onZoomOut)}
        resetZoom={(e) => handlePreviewControlAction(e, resetZoom)}
      />
    </div>
  );
};
